import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

// スクロール追従パララックス(汎用)
// .js-scrollparallax を付けた要素を data 属性の設定で動かす。ページ・要素を問わず使い回せる。
//   data-parallax-y       … スクロールしきった時に動く量(px)。マイナスで上方向=手前に見える(必須)
//   data-parallax-x       … 横方向の固定オフセット(xPercent)。センタリング等。スクロールでは動かさない(任意)
//   data-parallax-trigger … 基準にする要素のセレクタ。祖先なら closest、無ければ document から検索。未指定なら要素自身(任意)
//   data-parallax-start   … ScrollTrigger の start。既定 "top bottom"(任意)
//   data-parallax-end     … ScrollTrigger の end。既定 "bottom top"(任意)
//   data-parallax-media   … 動かす画面幅。"pc" は 1400px 以上、"wide" は 781px 以上、"narrow" は 780px 以下のみ(任意)
export default class ScrollParallax {
    constructor() {
        // motion低減設定では動かさない
        if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

        this.mm = gsap.matchMedia();

        document.querySelectorAll(".js-scrollparallax").forEach((target) => {
            const mediaQuery = this.getMediaQuery(target.dataset.parallaxMedia);

            if (mediaQuery) {
                this.mm.add(mediaQuery, () => this.setup(target));
                return;
            }

            this.setup(target);
        });
    }

    getMediaQuery(media) {
        if (media === "pc") return "(min-width: 1400px)";
        if (media === "wide") return "(min-width: 781px)";
        if (media === "narrow") return "(max-width: 780px)";
        return "";
    }

    setup(target) {
        const data = target.dataset;

        const y = parseFloat(data.parallaxY) || 0;
        const x = parseFloat(data.parallaxX) || 0;
        if (!y && !x) return;

        // 固定オフセットは set で先に当てておく(transform を GSAP に一元化する)
        if (x) gsap.set(target, { xPercent: x });
        if (!y) return;

        // 祖先優先で基準要素を解決。見つからなければ document 全体から。未指定なら要素自身。
        const selector = data.parallaxTrigger;
        const triggerEl = selector ? target.closest(selector) || document.querySelector(selector) : target;
        if (!triggerEl) return;

        gsap.to(target, {
            y,
            ease: "none",
            scrollTrigger: {
                trigger: triggerEl,
                start: data.parallaxStart || "top bottom",
                end: data.parallaxEnd || "bottom top",
                scrub: true,
            },
        });
    }
}
